// maxlength.js文件
 /**
 * v-maxlength 限制el-select允许allow-create时输入的最大长度
 */
 
 export default {
    inserted(el, binding, vnode) {
         let inputcontrol = el.querySelector('.el-select__input')
         inputcontrol.setAttribute("maxlength", binding.value);
    }
  }
 